import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"

import "./Skeleton.vue?vue&type=style&index=0&id=58726158&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58726158"]])

export default __exports__